module.exports = __webpack_public_path__ + "static/img/8.cbf8a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/8.png
// module id = I6fH
// module chunks = 1